import { useNavigate } from 'react-router';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BSTooltip from 'react-bootstrap/Tooltip';
import Spinner from 'react-bootstrap/Spinner';

import Header from '../components/Header';
import Footer from '../components/Footer';
import { CsvFileDownloadBtn } from '../components/CsvFileDownloadBtn';
import { QRCodeDownloadBtn } from '../components/QRCodeDownloadBtn';

import { fetchToken } from '../components/Auth';
import { useGetApi } from '../components/ApiAccess';
import { getSelfClient } from '../components/ApiAccess';
import { ClientName } from '../components/ApiAccess';
import { formatErrorMessage } from '../components/FormatErrorMassage';

/**
 * コンフリクト応答
 * @param {*} value
 * @param {*} conflictFile
 * @returns
 */
const conflictApply = (value, conflictFile) => {
  const headers = {
    accept: 'application/json',
    Authorization: 'Bearer ' + fetchToken(),
  };
  let putData = {
    name: conflictFile.name,
    status: '',
    is_overwrite: false,
  };

  if (value === 'overwrite') {
    putData.status = 'ACCEPT';
    putData.is_overwrite = true;
  } else if (value === 'notOverwrite') {
    putData.status = 'ACCEPT';
  } else if (value === 'cancel') {
    putData.status = 'REJECT';
  }

  const response = axios
    .put('/api/v1/files/' + conflictFile.id + '/', putData, { headers: headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });

  return response;
};

/**
 * コンフリクト内容を表示するエリア
 * @param {*} param0
 * @returns
 */
const ConflictArea = ({ status, fileInfo }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems([]);

    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    if (fileInfo && fileInfo.id) {
      axios.get('/api/v1/files/' + fileInfo.id + '/', { headers: headers }).then((res) => {
        if (res.data.status === 'REGISTERING') {
          const tmpConflictItem = res.data.items;
          setItems(tmpConflictItem);
        }
      });
    }
  }, [status, fileInfo]);

  return (
    <>
      {status === 'REGISTERING' ? (
        <>
          <div>
            <p className="text-danger fs-5 mb-1">coustomer_code重複検知</p>
            <div className="scroll-box p-2">
              <p className="">
                下記customer_codeに対して登録済みのurlとは異なる遷移先もしくは、異なるfree_textの設定を検知しました。
                <br />
                {items.map((value, index) => (
                  <span key={index}>
                    {value.customer_code || value.customer.code}
                    <br />
                  </span>
                ))}
              </p>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

/**
 * コンフリクト表示時の三択ボタン表示
 * @param {*} param0
 * @returns
 */
const Confirm3Buttons = ({ onConfirmClick }) => {
  const handleClick = (value) => {
    onConfirmClick(value);
  };

  return (
    <>
      <div className="mt-4">
        <Row className="justify-content-between gx-0">
          <Col xs={3}>
            <Button
              variant="dark"
              className="w-100 import-button"
              onClick={() => handleClick('overwrite')}
            >
              全て上書きして
              <br />
              インポート
            </Button>
          </Col>
          <Col xs={3}>
            <Button
              variant="dark"
              className="w-100 import-button"
              onClick={() => handleClick('notOverwrite')}
            >
              新規登録分のみ
              <br />
              インポート
            </Button>
          </Col>
          <Col xs={3}>
            <Button
              variant="dark"
              className="w-100 cancel-button"
              onClick={() => handleClick('cancel')}
            >
              中止
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

/**
 * サブミットボタン表示
 * @param {*} param0
 * @returns
 */
const SubmitArea = ({ status, registerStatus, onConfirmClick, state }) => {
  const handleClick = (value) => {
    onConfirmClick(value);
  };

  let isCreate = false;
  if (state && 'isCreate' in state) {
    isCreate = true;
  }

  return (
    <>
      {status === 'REGISTERING' ? (
        <>
          <Confirm3Buttons onConfirmClick={(value) => handleClick(value)} />
        </>
      ) : (
        <>
          <div className="text-center">
            {status === 'processing' || status === 'ENTRY' ? (
              <>
                <Button type="submit" variant="dark" disabled>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  ></Spinner>
                  <span className="visually-hidden">登録中...</span>
                </Button>
              </>
            ) : (
              <>
                <Button type="submit" variant="dark">
                  登録する
                </Button>
              </>
            )}
            {registerStatus === 'COMPLETED' || registerStatus === 'ACCEPT' || isCreate ? (
              <>
                <p className="mt-2 mb-0">インポート完了しました。</p>
              </>
            ) : (
              <></>
            )}
            {registerStatus === 'COMPLETED_without_file' ? (
              <>
                <p className="mt-2 mb-0">登録完了しました。</p>
              </>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
    </>
  );
};

/**
 * アップロードされたファイルの状態を表示するエリア
 * @param {*} param0
 * @returns
 */
const FileStatusMsg = ({ status, fileInfo }) => {
  const [fileStatusMsg, setFileStatusMsg] = useState('');
  useEffect(() => {
    setFileStatusMsg('');

    if (fileInfo) {
      const startTime = new Date(fileInfo.created_at);

      const endTime = new Date(fileInfo.updated_at);

      if (fileInfo.status === 'COMPLETED' || fileInfo.status === 'ACCEPT') {
        const msgTxt = (
          <>
            {endTime.toLocaleDateString()} {endTime.toLocaleTimeString()}
            <br />
            {startTime.toLocaleDateString()} {startTime.toLocaleTimeString()}{' '}
            にアップロードされたファイルのインポートは完了しました。
          </>
        );
        setFileStatusMsg(msgTxt);
      } else if (fileInfo.status === 'REJECT') {
        // ユーザー操作により中断
        const msgTxt = (
          <>
            {endTime.toLocaleDateString()} {endTime.toLocaleTimeString()}
            <br />
            最後にアップロードされたファイルは、ユーザー操作により中止されました。{' '}
          </>
        );
        setFileStatusMsg(msgTxt);
      } else if (fileInfo.status === 'ENTRY') {
        const msgTxt = <>{fileInfo.description}</>;
        setFileStatusMsg(msgTxt);
      }
    }
  }, [status, fileInfo]);

  return (
    <div className='file-status-message'>
      {status === 'REGISTERING' || status === 'processing' ? (
        <></>
      ) : (
        <>
          <div>
            <span>{fileStatusMsg}</span>
          </div>
        </>
      )}
    </div>
  );
};

/**
 * ダウンロードボタン表示領域
 * @param {*} param0
 * @returns
 */
const DownloadBtnAreaContent = ({ unitId, status }) => {
  return (
    <div className='download-button-area-content'>
      {status === 'REGISTERING' || status === 'ENTRY' || status === 'processing' ? (
        <>
          <p className="text-center m-0">
            <Spinner
              as="span"
              animation="border"
              size="lg"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span className="visually-hidden">待機中...</span>
          </p>
        </>
      ) : (
        <>
          <div className="table-row">
            <div className="table-cell">
              <div className="h5">登録データ確認</div>
              <p className="small-text">
                登録済みのユーザーはこちらから確認いただけます。
              </p>
              </div>
              <div className="table-cell text-end">
                <CsvFileDownloadBtn unitId={unitId} />
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">
                <p className="small-text">
                  QRサンプル出力：QRコードの出力をお試しいただけます。（※上限20件）
                </p>
              </div>
              <div className="table-cell text-end">
                <QRCodeDownloadBtn unitId={unitId} />
              </div>
            </div>
        </>
      )}
    </div>
  );
};

/**
 * 施策編集
 * @param {*} param0
 * @returns
 */
export default function EditUnit({ mode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const {
    register,
    watch,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm();

  const [errorResult, setErrorResult] = useState('');

  const [clientId, setClientId] = useState();
  const [unitId, setUnitId] = useState();

  const [clientName, setClientName] = useState();

  const [chooseFileName, setChooseFileName] = useState();

  const getClient = useGetApi('/api/v1/clients/' + params.clientId + '/');

  const dateFormatter = (date) => {
    if (!date) {
      date = new Date();
    }
    const y = date.getFullYear();
    const m = ('00' + (date.getMonth() + 1)).slice(-2);
    const d = ('00' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
  };

  const [unitData, setUnitData] = useState({ name: '', scope_start: '', scope_end: '' });

  const [loading, setLoading] = useState(true);

  const [viewStatus, setViewStatus] = useState('initial');

  const [uploadFileInfo, setUploadFileInfo] = useState({});

  const [registerStatus, setRegisterStatus] = useState('initial');

  /**
   * 初回のみ実行
   */
  useEffect(() => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };
    if (params.unitId) {
      setUnitId(params.unitId);

      //施策データの取得
      axios.get('/api/v1/units/' + params.unitId + '/', { headers: headers }).then((response) => {
        let unitDataTmp = {
          name: response.data.name,
          scope_start: response.data.scope_start,
          scope_end: response.data.scope_end,
        };
        setUnitData(unitDataTmp);

        setLoading(false);
      });
    }
  }, []);

  let intervalId;

  const fetchProcess = () => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    /**
     * アップロードされたファイルの状態を取得する
     */
    const fetchFileStatus = async () => {
      clearInterval(intervalId);

      // アップロードされたファイルの状態を取得する
      axios
        .get('/api/v1/units/' + params.unitId + '/files/?limit=1', { headers: headers })
        .then((res) => {
          let fileInfo = res.data[0];

          setUploadFileInfo(fileInfo);

          if (fileInfo.status === 'REGISTERING') {
            // 応答待ち
            setViewStatus('REGISTERING');

            setChooseFileName(fileInfo.name);
          } else {
            if (fileInfo && fileInfo.status) {
              setViewStatus(fileInfo.status);
            } else {
              setViewStatus('initial');
            }

            if (fileInfo.status === 'ENTRY' || fileInfo.status === 'APPLY-PROCESSING') {
              setViewStatus('ENTRY');

              intervalId = setInterval(() => {
                fetchFileStatus();
              }, 1000);
            }
          }
        });
    };

    intervalId = setInterval(() => {
      fetchFileStatus();
    }, 100);

    return () => clearInterval(intervalId);
  };

  /**
   * 最新のファイルが"REGISTERING"かチェック
   */
  useEffect(() => {
    setViewStatus('processing');

    return fetchProcess();
  }, []);

  /**
   * watch
   */
  useEffect(() => {
    if (!clientId) {
      if (params.clientId) {
        setClientId(params.clientId);
      } else {
        getSelfClient().then((response) => {
          setClientId(response.data.id);
        });
      }
    }

    const subscription = watch((value, { name, type }) => {
      if (name === 'fileb') {
        if (value.fileb.length > 0) {
          setChooseFileName(value.fileb[0].name);
        } else {
          setChooseFileName('');
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  /**
   * フォーム送信
   * @param {*} data
   */
  const regist = (data) => {
    setViewStatus('processing');
    setRegisterStatus('initial');

    /**
     * 施策内容UPDATE
     */
    // 施策情報更新
    updateUnit(data)
      .then((putRes) => {
        // ファイルアップロード
        if (data.fileb[0]) {
          fileUpload(data)
            .then((response) => {
              setViewStatus(response.data.status);
              setRegisterStatus(response.data.status);
              fetchProcess();
            })
            .catch((error) => {
              const newErrorResult = formatErrorMessage(error.response?.data);
              setErrorResult(newErrorResult);
              setViewStatus('COMPLETED');
              setTimeout(() => {
                window.scrollTo(0, 0);
              }, 200);
            });
        } else {
          setViewStatus('COMPLETED_without_file');
          setRegisterStatus('COMPLETED_without_file');
        }
        setErrorResult();
      })
      .catch((error) => {
        const newErrorResult = formatErrorMessage(error.response?.data);
        setErrorResult(newErrorResult);
        setViewStatus('COMPLETED');
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      });
  };

  /**
   * 施策内容UPDATE
   * @param {*} data
   * @returns
   */
  const updateUnit = (data) => {
    // putDataの作成
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };
    const putData = {
      name: data.unitName,
      scope_start: data.scopeStart || null,
      scope_end: data.scopeEnd || null,
    };

    // 施策情報更新
    const response = axios
      .put('/api/v1/units/' + unitId + '/', putData, { headers: headers })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });

    return response;
  };

  /**
   * ファイルをアップロードする
   * @param {*} data
   * @returns
   */
  const fileUpload = (data) => {
    setViewStatus('ENTRY');

    // ファイルアップデート
    // postFileの作成
    const fileHeaders = {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const postFile = { fileb: data.fileb[0] };

    //  ファイルをアップロードする
    const response = axios
      .post('/api/v1/units/' + unitId + '/files/', postFile, { headers: fileHeaders })
      .then((postRes) => {
        return postRes;
      })
      .catch((error) => {
        return Promise.reject(error);
      });

    return response;
  };

  /**
   * コンフリクト時の三択応答ハンドラー
   * @param {*} value
   */
  const handleConfirmClick = (value) => {
    conflictApply(value, uploadFileInfo)
      .then((response) => {
        setViewStatus(response.data.status);
        setRegisterStatus(response.data.status);

        setUploadFileInfo(response.data);

        fetchProcess();

        // if (value === 'overwrite') {
        //   setViewStatus('COMPLETED');
        // } else if (value === 'notOverwrite') {
        //   setViewStatus('COMPLETED');
        // } else if (value === 'cancel') {
        //   setViewStatus('initial');
        // }
      })
      .catch((error) => {
        const newErrorResult = formatErrorMessage(error.response?.data);
        setErrorResult(newErrorResult);
      });
  };

  if (loading) {
    return <></>;
  }

  return (
    <div className={'edit-unit'}>
      <Header></Header>
      <main>
        <Container>
          <h2>施策編集</h2>
          {errorResult && (
            <Alert key={'danger'} variant={'danger'} className='error-result-message'>
              エラー:
              <br />
              {errorResult.map((htmlString, index) => (
                <React.Fragment key={index}>
                  {htmlString}
                  <br />
                </React.Fragment>
              ))}
            </Alert>
          )}
          <div className={'form-wrapper'}>
            <Form noValidate onSubmit={handleSubmit(regist)}>
              <Form.Group className="mb-4">
                <Form.Label className="h5">企業</Form.Label>
                <ClientName as={Form.Control} clientId={clientId} plaintext readOnly />
              </Form.Group>

              <Form.Group className="mb-4" controlId="unitName">
                <Form.Label className="h5">
                  施策名
                  <Badge bg="danger" className="ms-2">
                    必須
                  </Badge>
                </Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={unitData.name}
                  isInvalid={!!errors.unitName}
                  {...register('unitName', {
                    required: true,
                    validate: false,
                  })}
                />
                {errors.unitName && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label className="h5">施策期間</Form.Label>
                <Row>
                  <Col>
                    <Form.Control
                      type="date"
                      defaultValue={unitData.scope_start}
                      isInvalid={!!errors.scopeStart}
                      {...register('scopeStart', {
                        required: false,
                        validate: (value) => {
                          if (value === '') {
                            return '開始日は入力が必須です';
                          }
                        },
                      })}
                    />
                    {errors.scopeStart && (
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage
                          errors={errors}
                          name="scopeStart"
                          render={({ message }) => <p>{message}</p>}
                        />
                      </Form.Control.Feedback>
                    )}
                  </Col>
                  <Col xs="auto" className="py-2">
                    から
                  </Col>
                  <Col>
                    <Form.Control
                      type="date"
                      defaultValue={unitData.scope_end}
                      isInvalid={!!errors.scopeEnd}
                      {...register('scopeEnd', {
                        required: false,
                        validate: (value) => {
                          // 開始日の入力がないとき、終了日は今日以降の日付でなければならない
                          if (
                            watch('scopeStart') === '' &&
                            value !== '' &&
                            dateFormatter() > value
                          ) {
                            return '今日より後の日付を入力してください';
                            // 開始日の入力があるとき、終了日は開始日以降の日付でなければならない
                          } else if (
                            watch('scopeStart') !== '' &&
                            value !== '' &&
                            watch('scopeStart') > value
                          ) {
                            return '開始日より後の日付を入力してください';
                          }
                        },
                      })}
                    />
                    {errors.scopeEnd && (
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage
                          errors={errors}
                          name="scopeEnd"
                          render={({ message }) => <p>{message}</p>}
                        />
                      </Form.Control.Feedback>
                    )}
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label className="h5">
                  CSVインポート
                  <OverlayTrigger
                    placement="bottom"
                    trigger={['hover', 'focus']}
                    overlay={
                      <BSTooltip id="info-tooltip">
                        csvのfreetext列は128文字以下で自由に記載いただけますが
                        <br />
                        個人情報の取り扱いには十分ご注意ください
                      </BSTooltip>
                    }
                  >
                    <img src="/manager/info-circle.svg" className="ms-2 mb-1" width="20px" />
                  </OverlayTrigger>
                </Form.Label>
                <Row>
                  <Col className="col-auto">
                    <Button
                      variant="link"
                      href="/manager/accuriodx_template.csv"
                      download="accuriodx_template.csv"
                      className="button-link ps-0 pe-0"
                    >
                      テンプレートファイルをダウンロードする
                    </Button>
                  </Col>
                </Row>
                <Form.Group className="custom-file" controlId="fileb">
                  <Form.Control
                    type="file"
                    placeholder=""
                    className='custom-file-input'
                    isInvalid={false}
                    {...register('fileb', { required: false })}
                  />
                  <Row>
                    <Col className="col-auto">
                      <Form.Label className="custom-file-label btn btn-outline-secondary">
                        ファイル選択
                      </Form.Label>
                    </Col>
                    <Col>
                      {chooseFileName && <Form.Control plaintext readOnly value={chooseFileName} />}
                    </Col>
                  </Row>
                  {/* {errors.fileb && (
                    <Form.Control.Feedback type="invalid">
                      入力が必須の項目です
                    </Form.Control.Feedback>
                  )} */}
                </Form.Group>
              </Form.Group>

              <ConflictArea status={viewStatus} fileInfo={uploadFileInfo} />

              <SubmitArea
                status={viewStatus}
                registerStatus={registerStatus}
                onConfirmClick={(value) => handleConfirmClick(value)}
                state={location.state}
              />

              <FileStatusMsg status={viewStatus} fileInfo={uploadFileInfo} />
            </Form>
          </div>

          <div id="data-output-area" className="text-center d-block">
            <div className="wrapper text-start download-button-bg">
              <div className="wrapper download-button-area">
                <DownloadBtnAreaContent unitId={unitId} status={viewStatus} />
              </div>
            </div>

            <div className="d-block">
              <div className="wrapper">
                <div className="bottom-button-content-row">
                  <Button variant="outline-primary" href={'../new'} size="sm">
                    新規で施策登録
                  </Button>
                  <Button variant="outline-primary" href={'../'} size="sm">
                    施策一覧に戻る
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
